<template>
  <div class="shopping-manage-container">
    <div>
      <h2>商品管理</h2>
      <!-- 导入导出按钮 -->
      <div class="operation-buttons">
        <!-- <el-button type="primary" icon="el-icon-plus" @click="addShop()">添加商品</el-button> -->
        <!-- <el-button icon="el-icon-download">批量导入</el-button>
        <el-button icon="el-icon-upload2">批量导出</el-button> -->
      </div>
      <!-- 筛选按钮 -->
      <div class="filter-container">
        <div class="filter-left">
          <el-input placeholder="搜索商品名称" prefix-icon="el-icon-search" v-model="searchForm.keyword"
            class="search-input"></el-input>
          <!-- @change="changeType" -->
          <el-select v-model="searchForm.categoryId" placeholder="所有分类" class="filter-select" clearable>
            <el-option v-for="item in shoppingType" :key="item.id" :label="item.value" :value="item.id">
            </el-option>
          </el-select>
          <!-- @change="changeState" -->
          <el-select v-model="searchForm.status" placeholder="所有状态" class="filter-select" clearable>
            <el-option v-for="item in stateList" :key="item.id" :label="item.value" :value="item.id">
            </el-option>
          </el-select>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="clear">清空</el-button>
        </div>
        <div class="filter-right">
          <el-button type="primary" icon="el-icon-plus" @click="addShop()">添加商品</el-button>
        </div>
      </div>

      <div class="table-container">
        <el-table :data="tableData" border stripe width="100%">
          <el-table-column label="商品信息" align="center">
            <template slot-scope="scope">
              <div class="product-info">
                <img v-if="scope.row.img2" :src="scope.row.img2" class="product-image">
                <div class="product-detail">
                  <div class="product-name">{{ scope.row.name }}</div>
                  <div class="product-spec">{{ scope.row.specification }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="价格" align="center">
            <template slot-scope="scope">
              <div class="price-info">
                <div class="current-price">¥{{ scope.row.goodsProducts ? scope.row.goodsProducts[0].price : 0 }}</div>
                <!-- <div class="original-price">¥{{ scope.row.originalPrice }}</div> -->
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="stockNum" label="库存" align="center"></el-table-column>
          <el-table-column prop="soldNum" label="销量" align="center"></el-table-column>

          <el-table-column label="评分" align="center">
            <template slot-scope="scope">
              <div class="rating">
                <!-- :class="n <= Math.round(scope.row.rating) ? 'el-icon-star-on' : 'el-icon-star-off'"
                       :style="{ color: n <= Math.round(scope.row.rating) ? '#F7BA2A' : '#CDCDCD' }"
                   -->
                <div class="stars">
                  <i v-for="n in 1" :key="n" class="el-icon-star-on"></i><span class="rating-count"
                    style="font-weight: 400; font-size: 15px;">{{ scope.row.averageScore }}</span><span
                    class="rating-count">({{ scope.row.averageNumber }})</span>
                </div>

              </div>
            </template>
          </el-table-column>

          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.statusType2">{{ scope.row.stockstatus2 }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-tooltip content="查看详情" placement="top">
                <el-button type="primary" icon="el-icon-view" size="mini" circle @click="detail(scope)"></el-button>
              </el-tooltip>
              <el-tooltip content="编辑" placement="top">
                <el-button type="primary" icon="el-icon-edit" size="mini" circle @click="edit(scope)"></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="delect(scope)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <div class="page-info">显示 {{ query.pageNum }} 到 {{ query.pageSize }} 条，共 {{ total }} 条</div>
          <el-pagination background layout="prev, pager, next" :total="total" :current-page="query.pageNum"
            :page-size="query.pageSize" @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
      <!-- 添加商品弹窗 -->
      <el-dialog title="商品上架" :visible.sync="dialogVisible" width="70%" :before-close="downDialogVisible">
        <el-form :model="productForm" :rules="rules" ref="productFormRef" label-width="120px" class="product-form">
          <el-form-item label="商品分类" prop="categoryId">
            <!-- <el-input v-model="productForm.category" placeholder="请选择商品类别"></el-input> -->
            <!-- <el-select v-model="productForm.categoryId" :disabled="isDetail" placeholder="所有分类" class="filter-select">
              <el-option v-for="item in shoppingType" :key="item.id" :label="item.value" :value="item.id">
              </el-option>
            </el-select> -->
            <el-cascader ref="shopType" v-model="productForm.categoryId" :props="props" :options="shoppingType"
              :show-all-levels="false" @change="regionChange" clearable></el-cascader>
          </el-form-item>


          <el-form-item label="商品标题" prop="name">
            <el-input v-model="productForm.name" :disabled="isDetail" placeholder="请输入商品标题"></el-input>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="品牌信息" prop="brand">
                <el-input v-model="productForm.brand" :disabled="isDetail" placeholder="请输入品牌名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="库存数量" prop="stockNum">
                <el-input v-model="productForm.stockNum" :disabled="isDetail" placeholder="请输入库存数量"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="商品规格" prop="specification">
            <el-input v-model="productForm.specification" :disabled="isDetail" placeholder="请输入商品规格"></el-input>
          </el-form-item>

          <div class="TitAndAdd" style="display: flex; padding-bottom: 20px;">
            <span style="padding-left: 40px; padding-right: 10px;">规格及价格</span>
            <span @click="addSpecificationsAndPrices"
              style="background: #D97D53; color: white; padding: 2px 5px;border-radius: 2px;">添加套餐</span>
          </div>
          <el-row :gutter="24" v-for="(item, index) in productForm.productList" :key="index">
            <el-col :span="6">
              <el-form-item :prop="`productList.${index}.num`">
                <template #label>
                  <span style="color: #F56C6C">*</span> 商品数量
                </template>
                <el-input v-model="item.num" :disabled="isDetail" placeholder="请输入数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item :prop="`productList.${index}.price`">
                <template #label>
                  <span style="color: #F56C6C">*</span> 套餐价格
                </template>
                <el-input v-model="item.price" :disabled="isDetail" placeholder="￥" style="width: 180px;">
                  <div slot="prefix">￥</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" style="margin-left: 50px;">
              <el-form-item label="包邮">
                <el-switch :disabled="isDetail" active-value="1" inactive-value="0" v-model="item.mailFlag"
                  active-color="#13ce66" @change="handleMailFlagChange(item, index)"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-show="item.mailFlag == 0">
              <el-form-item label="邮费">
                <el-input v-model="item.mailPrice" :disabled="isDetail" prefix="￥" style="width: 180px;">
                  <div slot="prefix">￥</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="danger" icon="el-icon-delete" circle @click="removeSpecification(index)"
                  :disabled="isDetail"></el-button>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="商品主图" prop="img">
            <div class="main-img-upload">
              <div v-for="(item, index) in productForm.img" :key="index" class="img-preview"
                style="position: relative;">
                <el-image :src="item.url2" fit="cover" style="width: 100%; height: 100%;" />
                <el-button v-if="!isDetail" class="img-remove" type="danger" icon="el-icon-close" size="mini" circle
                  @click="removeImage(index)" style="position: absolute; top: 6px; right: 6px; z-index: 2;">
                </el-button>
              </div>
              <el-upload v-if="!isDetail && productForm.img.length < 6" drag class="upload-demo square-upload" action=""
                multiple :on-change="upImg" :auto-upload="false" :limit="6" :on-preview="handlePreview"
                :on-remove="handleRemove" :file-list="fileList" :show-file-list="false"
                :before-upload="beforeImgUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">点击或拖拽图片上传</div>
                <div class="el-upload__text upload-tip-bottom">支持 JPG、PNG 格式</div>
                <!-- <div class="el-upload__text upload-tip-bottom">大小不超过5MB</div> -->
              </el-upload>
            </div>
          </el-form-item>


          <el-form-item label="商品详情描述" prop="detail">
            <div style="border: 1px solid #ccc;">
              <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
                :mode="mode" />
              <Editor style="height: 500px; overflow-y: hidden" v-model="productForm.detail"
                :defaultConfig="editorConfig" :mode="mode" ref="medit" @onCreated="onCreated" @onBlur="validateDetail" />
            </div>
          </el-form-item>

          <el-form-item label="立即上架">
            <el-switch :disabled="isDetail" v-model="productForm.saleStatus" active-value="1" inactive-value="0"
              active-color="#13ce66"></el-switch>
          </el-form-item>

          <el-form-item prop="productList" style="display:none"></el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer" v-if="!isDetail">
          <el-button @click="Cancel">取消</el-button>
          <el-button type="primary" @click="saveProduct">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { uploadFile } from "@/api/fileApi";
import { removeEmptyChildren } from "@/js/utils/util";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { updateGoods, selectPcPageList, tree, saveGoods, appletPcDetail, deleteGoods } from '@/api/sjzx'
// import { clear } from 'console';

export default {
  components: { Editor, Toolbar },
  name: 'shoppingManage',
  data() {
    return {
      baseUrl: window.globalUrl.HOME_API,
      type: 0,//0代表新增，1代表编辑
      searchForm: {
        keyword: '',//搜索名称
        categoryId: '',//搜索商品类型
        status: '',//搜索商品状态
      },
      query: {
        pageNum: 1,
        pageSize: 10,
      },
      currentPage: 1,
      dialogVisible: false,
      shoppingType: [],//商品类别列表
      // shopImgList:[],//商品列表
      total: 0,//列表总数
      stateList: [
        {
          id: '0',
          value: '已下架'
        },
        {
          id: '1',
          value: '已上架'
        }, {
          id: '2',
          value: '库存紧张'
        },
        {
          id: '3',
          value: '已售罄'
        }
      ],//所有状态列表
      props: {
        label: "value",
        children: "children",
        value: "id",
        checkStrictly: true,
      },

      productForm: {
        categoryId: '',//商品类别id
        specification: '',//商品规格
        name: '',//商品标题
        brand: '',//品牌信息
        stockNum: '',//库存数量
        productList: [{
          mailFlag: 0,//是否包邮
          mailPrice: '',//邮费
          price: '',//价格
          num: '',//数量
        }
        ],//规格及价格列表
        img: [],//商品主图
        detail: '',//商品详情描述
        saleStatus: "1",//立即上架
      },
      fileList: [],//图片列表

      tableData: [],
      wordCount: 0,
      predefineColors: [
        '#000000',
        '#FF5733',
        '#C70039',
        '#900C3F',
        '#581845',
        '#2E86C1',
        '#17A589',
        '#D4AC0D'
      ],
      // 富文本
      editor: null,
      html: "<p>hello</p>",
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          uploadImage: {
            // 自定义上传
            async customUpload(file, insertFn) {
              // 构建 FormData
              let param = new FormData();
              param.append("catalog", "register");
              param.append("file", file);

              // 上传图片
              let res = await uploadFile(param);
              if (res.code == 0) {
                const { url } = res.data;
                // 拼接完整图片地址
                const fullUrl = window.globalUrl.HOME_API + "admin/file/get?ossFilePath=" + url;
                // 插入图片到编辑器
                insertFn(fullUrl, '', fullUrl);
              } else {
                // 失败处理
                this.$message.error('图片上传失败');
              }
            }
          }
        }
      },
      mode: "default", // or 'simple'
      rules: {
        categoryId: [
          { required: true, message: '请选择商品分类', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        brand: [
          { required: true, message: '请输入品牌信息', trigger: 'blur' }
        ],
        stockNum: [
          { required: true, message: '请输入库存数量', trigger: 'blur' }
        ],
        specification: [
          { required: true, message: '请输入商品规格', trigger: 'blur' }
        ],
        img: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请上传商品主图'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        productList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('请添加至少一个套餐'));
              } else {
                for (let i = 0; i < value.length; i++) {
                  if (!value[i].num) {
                    callback(new Error(`第${i + 1}个套餐的商品数量不能为空`));
                    return;
                  }
                  if (!value[i].price && value[i].price !== 0) {
                    callback(new Error(`第${i + 1}个套餐的套餐价格不能为空`));
                    return;
                  }
                  if (value[i].mailFlag == 0 && (value[i].mailPrice === '' || value[i].mailPrice === undefined || value[i].mailPrice === null)) {
                    callback(new Error(`第${i + 1}个套餐的邮费不能为空`));
                    return;
                  }
                }
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        detail: [
          {
            required: true,
            validator: (rule, value, callback) => {
              // 去除空格后判断
              const val = (value || '').replace(/<p><br><\/p>/ig, '').replace(/<p><\/p>/ig, '').replace(/&nbsp;/ig, '').trim();
              if (!val) {
                callback(new Error('请输入商品详情描述'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      isDetail: false,
    }
  },
  created() {
    // this.getIsHave()
  },
  mounted() {
    this.getSelectPcPageList()
    this.getTreeList()
    // this.getSelectShipCompany()

  },
  computed: {
    ...mapGetters([
      "identityObj",
    ]),
  },
  methods: {
    // 搜索按钮
    search() {
      this.query.pageNum=1
      this.getSelectPcPageList()
    },
    // 清空按钮
    clear() {
      this.searchForm= {
        keyword: '',//搜索名称
        categoryId: '',//搜索商品类型
        status: '',//搜索商品状态
      }
      this.getSelectPcPageList()
    },
    regionChange() {
      //选择商品分类
      let node = this.$refs.shopType.getCheckedNodes()[0];
      this.productForm.categoryId = node.value
    },
    //判断是草稿还是保存
    // getIsHave() {
    //   //0保存，1草稿

    //   // let identityObj = localStorage.getItem("identityObj") || []
    //   // 从本地存储加载草稿
    //   const draft = localStorage.getItem('identityObj')
    //   if (draft) {
    //     try {
    //       const identityObj = JSON.parse(draft)
    //       if (identityObj) {
    //         // let obj = JSON.parse(identityObj)
    //         this.IsHaveobj = identityObj.content.shop.draftFlag == null ? false : identityObj.content.shop.draftFlag == 0 ? true : false
    //         console.log(this.IsHave, '查看this.IsHave')
    //       }
    //     } catch (e) {
    //       console.error('解析草稿数据失败', e)
    //     }
    //   }

    // },
    // 交互层
    async upImg(file, fileList) {
      try {
        let param = new FormData();
        param.append("catalog", "register");
        param.append("file", file.raw);
        let res = await uploadFile(param);
        if (res.code == 0) {
          const { url, sourceFileName } = res.data
          this.fileList = fileList
          this.productForm.img.push({
            name: sourceFileName,
            url: url,
            url2: this.baseUrl + "admin/file/get?ossFilePath=" + url
          })
          this.$refs.productFormRef && this.$refs.productFormRef.clearValidate(['img']);
        } else {
          this.$message.error(res.msg || '连接异常，请稍后再试');
        }
      } catch (e) {
        this.$message.error('连接异常，请稍后再试');
      }
    },


    onCreated(editor) {
      // 富文本
      this.editor = Object.seal(editor); 
    },
    handleCurrentChange(val) {
      // 分页切换
      this.query.pageNum = val;
      // console.log(val,'查看val')
      this.getSelectPcPageList()
    },

    addSpecificationsAndPrices() {
      // 新增一个空的规格及价格
      this.productForm.productList.push(
        {
          mailFlag: 0,//是否包邮
          mailPrice: '',//邮费
          price: '',//价格
          num: '',//数量
        }
      )
    },
    updateDescription() {
      if (this.$refs.richEditor) {
        // 获取纯文本内容并计算字数
        const text = this.$refs.richEditor.innerText || '';
        this.wordCount = text.trim().length;

        // 保存富文本内容到productForm
        this.productForm.description = this.$refs.richEditor.innerHTML;
      }
    },
    clearEditor() {
      if (this.$refs.richEditor) {
        this.$refs.richEditor.innerHTML = '<p>在这里输入商品详情描述...</p>';
        this.updateDescription();
      }
    },

    //控制层
    open() {
      //跳转注册页面路由
      this.$router.push({ name: "supplierRegistration" });
    },
    handleRemove(file, fileList) {
      //删除图片
      this.productForm.img = fileList
    },
    handlePreview(file) {
      console.log(file);
    },
    downDialogVisible() {
      //关闭弹窗清数据
      this.dialogVisible = false;
      this.productForm = {
        categoryId: '',//商品类别id
        specification: '',//商品规格
        name: '',//商品标题
        brand: '',//品牌信息
        stockNum: '',//库存数量
        productList: [{
          mailFlag: 0,//是否包邮
          mailPrice: '',//邮费
          price: '',//价格
          num: '',//数量
        }
        ],//规格及价格列表
        img: [],//商品主图
        detail: '',//商品详情描述
        saleStatus: '1',//立即上架
      }

    },
   
    Cancel() {
      this.downDialogVisible()
    },
    //提交商品
    async saveProduct() {
      this.$refs.productFormRef.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请完善必填项');
          return;
        }

        // 这里实现保存商品的逻辑
        let newData = JSON.parse(JSON.stringify(this.productForm))
        newData.img = this.getImgList(newData.img)
        // console.log(newData, '查看newData')
        let params = {
          ...newData,
        }
        // console.log(params,'查看params')
        if (this.type == 0) {
          let res = await saveGoods(params)
          if (res.code == 0) {
            this.downDialogVisible()
            // this.dialogVisible = false;
            this.getSelectPcPageList()
            this.$message.success(res.msg)
          }
          else {
            this.$message.error(res.msg)
          }
        } else {
          // productList 的 productId 改为 id
          if (Array.isArray(params.productList)) {
            params.productList = params.productList.map(item => {
              if (item.productId !== undefined) {
                item.id = item.productId;
                delete item.productId;
              }
              return item;
            });
          }
          let res = await updateGoods(params)
          if (res.code == 0) {
            this.downDialogVisible()
            // this.dialogVisible = false;
            this.getSelectPcPageList()
            this.$message.success(res.msg)
          }
        }
      });
    },

    async detail(scope) {
      //查看详情
      let params = {
        id: scope.row.id
      }
      let res = await appletPcDetail(params)
      if (res.code == 0) {
        this.isDetail = true;
        this.dialogVisible = true;
        res.data.img = res.data.img ? JSON.parse(res.data.img) : [];
        res.data.img = res.data.img.map(item => ({
          ...item,
          url2: this.baseUrl + "admin/file/get?ossFilePath=" + item.url
        }));
        this.productForm = res.data;
      } else {
        this.$message.error('打开失败')
        this.dialogVisible = false;
      }
    },
    addShop() {
      this.type = 0
      this.isDetail = false;
      this.dialogVisible = true
    },
    async edit(scope) {
      this.type = 1
      this.isDetail = false;
      let params = {
        id: scope.row.id
      }
      let res = await appletPcDetail(params)
      if (res.code == 0) {
        this.dialogVisible = true;
        res.data.img = res.data.img ? JSON.parse(res.data.img) : [];
        res.data.img = res.data.img.map(item => ({
          ...item,
          url2: this.baseUrl + "admin/file/get?ossFilePath=" + item.url
        }));
        this.productForm = res.data;

      } else {
        this.$message.error('打开失败')
        this.dialogVisible = false;
      }
    },
    delect(scope) {
      let params = {
        id: scope.row.id
      }
      this.$confirm('此操作将永久删除该商品，是否继续？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        distinguishCancelAndClose: true,
        iconClass: 'el-icon-warning-outline'
      }).then(async () => {
        let res = await deleteGoods(params)
        if (res.code == 0) {
          this.getSelectPcPageList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
      }).catch(action => {
        if (action === 'cancel') {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        }
      });
    },

    //数据层

    getImgList(arr) {
      console.log(arr)
      const newArr = arr.map(item => ({
        url: item.url,
        name: item.name
      }));
      console.log(newArr, '查看newArr')
      return JSON.stringify(newArr);
    },
    getChangeList(arr) {

      // 改变数据格式// 改变数据格式
      const newArr = arr.map(item => {

        // 使用扩展运算符来复制对象，并添加新的属性
        return {
          ...item,
          img2: (() => {
            if (!item.img) return '';
            let arr;
            try {
              arr = JSON.parse(item.img);
            } catch (e) {
              return '';
            }
            return Array.isArray(arr) && arr.length > 0
              ? this.baseUrl + 'admin/file/get?ossFilePath=' + arr[0].url
              : '';
          })(),
          stockstatus2: item.status == 1 ? (item.stockStatus == 0 ? '已售罄' : item.stockStatus == 1 ? '库存紧张' : item.stockStatus == 2 ? '已上架' : '') : '已下架',
          statusType2: item.stockStatus == "0" ? 'danger' : item.stockStatus == 1 ? 'success' : item.stockStatus == 2 ? 'primary' : 'primary'
        };
      });
      // console.log(newArr,'查看newArrimg2')
      // 现在 newArr 是一个包含新格式对象的新数组
      return newArr;

    },
    async getSelectPcPageList() {
      //商品管理列表
      let params = {
        ...this.searchForm,
        ...this.query,
      }
      let res = await selectPcPageList(params)
      if (res.code == 0) {
        this.tableData = this.getChangeList(res.data.records)
        this.total = Number(res.data.total)
        // console.log(this.tableData, 'this.tableData')
      }
    },
    async getTreeList() {
      //商品分类列表
      let params = {
        level: "2",
        // parentId:''
      }
      let res = await tree(params)
      this.shoppingType = removeEmptyChildren(res.data)
    },
    removeImage(index) {
      this.productForm.img.splice(index, 1);
    },
    //校验不能大于5MB
    beforeImgUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isLt5M;
    },
    removeSpecification(index) {
      //删除单个规格
      this.productForm.productList.splice(index, 1);
    },
    //自定义必传校验，因为富文本带有标签所以不能单纯的判断是否为空，需要判断多种情况
    validateDetail() {
      this.$refs.productFormRef && this.$refs.productFormRef.validateField('detail');
    },
    handleMailFlagChange(item, index) {
      if (item.mailFlag == 1) {
        this.$set(this.productForm.productList[index], 'mailPrice', 0);
      }
    },
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.shopping-manage-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;

  .page-title {
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 18px;
  }

  .operation-buttons {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }

  .filter-container {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    .filter-left {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .filter-right {
      // 可根据需要添加样式
    }

    .search-input {
      width: 350px;
    }

    .filter-select {
      width: 150px;
    }
  }

  .table-container {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    overflow-x: auto;

    .product-info {
      display: flex;
      align-items: center;
      padding: 5px;

      .product-image {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        object-fit: cover;
        border-radius: 2px;
      }

      .product-detail {
        display: flex;
        flex-direction: column;
        text-align: left;

        .product-name {
          font-weight: bold;
          font-size: 14px;
          margin-bottom: 4px;
          color: #333;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .product-spec {
          color: #999;
          font-size: 12px;
        }
      }
    }

    .price-info {
      .current-price {
        color: #303133;
        font-weight: 500;
        font-size: 14px;
      }

      .original-price {
        color: #909399;
        font-size: 12px;
        text-decoration: line-through;
        margin-top: 2px;
      }
    }

    .rating {
      display: flex;
      // flex-direction: column;
      align-items: center;
      justify-content: center;

      .stars {
        // display: flex;
        // margin-bottom: 3px;

        i {
          font-size: 14px;
          margin: 0 1px;
          color: #F7BA2A;
        }
      }

      .rating-count {
        color: #909399;
        font-size: 12px;
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .page-info {
      color: #606266;
      font-size: 13px;
    }
  }
}

// 商品表单样式
.product-form {
  .el-form-item {
    margin-bottom: 20px;

    /deep/ .el-form-item__label {
      float: left;
      line-height: 40px;
      padding-right: 12px;
      width: 120px;
      text-align: right;
    }

    /deep/ .el-form-item__content {
      margin-left: 120px;
    }

    /deep/ .el-input__inner {
      border-radius: 8px;
      border: 1px solid #dcdfe6;
      transition: border-color 0.2s;

      &:focus {
        border-color: #409eff;
      }
    }
  }

  .upload-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 5px;
  }
}

// 对话框样式覆盖
:deep(.el-dialog__header) {
  border-bottom: 1px solid #EBEEF5;
  padding: 15px 20px;
}

:deep(.el-dialog__body) {
  padding: 20px;
}

:deep(.upload-demo) {
  width: 100%;
}

/deep/.el-upload {
  width: 100%;

  /deep/.el-upload-dragger {
    width: 100%;
  }
}

/deep/.el-upload-dragger {
  width: 100%;
}


/deep/.w-e-bar {
  display: flex;
}

.white-bg {
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: 800;
}

.main-img-upload {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  flex-wrap: wrap;

  .img-preview,
  .square-upload {
    width: 140px;
    height: 140px;
    border-radius: 10px;
    overflow: hidden;
    border: 1.5px solid #e5e6eb;
    background: #fafbfc;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
    transition: box-shadow 0.2s, border-color 0.2s;
  }

  .img-preview {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      border-radius: 10px;
    }

    // 删除按钮（可选）
    .img-remove {
      position: absolute;
      top: 6px;
      right: 6px;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border: none;
      border-radius: 50%;
      width: 22px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 16px;
      z-index: 2;
      transition: background 0.2s;

      &:hover {
        background: #d9534f;
      }
    }
  }

  .square-upload {
    cursor: pointer;
    border: 1.5px dashed #c0c4cc;
    background: #fcfcfd;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:hover {
      border-color: #409eff;
      box-shadow: 0 4px 16px 0 rgba(64, 158, 255, 0.08);
    }

    /deep/ .el-upload-dragger {
      width: 100%;
      height: 100%;
      background: transparent;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: none;
      box-shadow: none;
    }

    i.el-icon-upload {
      font-size: 38px;
      color: #bfcbd9;
      margin-bottom: 8px;
    }

    .el-upload__text {
      font-size: 13px;
      color: #999;
      text-align: center;
      margin-top: 0;
      line-height: 1.5;

    }
  }
}

.upload-tip-bottom {
  margin-bottom: 25px;
  display: block;
}
</style>
